/** ArticleBreadcrumb (G2, D9, P4): nav[aria-label] > ol; the current page is text (aria-current). BreadcrumbList JSON-LD is built at publish (Task 13). */
import React, { memo } from 'react';
import { ChevronRight } from '@modules/screen-view-v2/components/screens/FlexibleLayout/article/articleIcons';
import type { ArticleBlockProps } from '@modules/screen-view-v2/components/screens/FlexibleLayout/article/types';
import { articleLinkTargetProps, resolveArticleHref } from '@modules/screen-view-v2/utils/articleLinks';
import { resolveLocaleText } from '@modules/screen-view-v2/utils/articleText';

export const ArticleBreadcrumb = memo(function ArticleBreadcrumb({ section, locale, article }: ArticleBlockProps): React.ReactElement | null {
  const content = section.articleBreadcrumbContent;
  if (!content) return null;
  const items = content.items ?? [];
  const current = resolveLocaleText(content.current, locale);
  const siteOrigin = article.runtime?.siteOrigin;
  return (
    <nav className="ap-block ap-breadcrumb" aria-label="Breadcrumb">
      <ol className="ap-crumbs">
        {items.map((item, index) => {
          const text = resolveLocaleText(item.label, locale);
          const href = resolveArticleHref(item.href);
          return (
            <li key={`${index}:${item.href}`} className="ap-crumb">
              {index > 0 ? <ChevronRight className="ap-crumb-sep" /> : null}
              {href ? <a href={href} {...articleLinkTargetProps(href, item.target, siteOrigin)}>{text}</a> : <span>{text}</span>}
            </li>
          );
        })}
        {current ? (
          <li className="ap-crumb">
            {items.length > 0 ? <ChevronRight className="ap-crumb-sep" /> : null}
            <span aria-current="page">{current}</span>
          </li>
        ) : null}
      </ol>
    </nav>
  );
});

ArticleBreadcrumb.displayName = 'ArticleBreadcrumb';
